import SideNavigation from "@cloudscape-design/components/side-navigation";
import Box from "@cloudscape-design/components/box";

/**
 * CommonNavigation - Shared navigation component for document processing
 *
 * Simplified navigation showing only document processing functions,
 * admin panel, and user settings (dark mode, language, logout).
 *
 * @param {string} activeHref - Currently active navigation item
 * @param {object} header - Navigation header (text and href)
 * @param {function} onFollow - Navigation click handler
 * @param {array} interfaceItems - Interface-specific navigation items
 * @param {boolean} isAdmin - Whether user has admin access
 * @param {array} additionalNavItems - i18n controls (dark mode, language, logout)
 * @param {string} currentInterface - Current interface name for highlighting
 */
function CommonNavigation({ activeHref, header, onFollow, interfaceItems = [], isAdmin = false, additionalNavItems = [], currentInterface = "documents" }) {
  // Build the complete navigation items array
  const navigationItems = [
    // 1. Interface-Specific Items (dashboard, document management, configuration)
    ...interfaceItems,

    // 2. i18n Controls (dark mode, language, logout)
    ...(Array.isArray(additionalNavItems) ? additionalNavItems : []),
  ];

  return (
    <div>
      <div style={{ padding: "16px 20px 4px" }}>
        <img src="/avatar192.png" alt="" width="192" height="192" style={{ borderRadius: "12px" }} />
      </div>
      <div style={{ padding: "8px 20px 4px" }}>
        <Box variant="h3" padding="n">
          <a href={header.href} style={{ color: "inherit", textDecoration: "none" }}>
            {header.text}
          </a>
        </Box>
      </div>
      <SideNavigation activeHref={activeHref} onFollow={onFollow} items={navigationItems} />
    </div>
  );
}

export default CommonNavigation;
